<template>
  <div class="bnews blue2 prelative fs16 cpointer ofhidden" @click="goRoute(item.id)">
    <div class="dinline-block tc6 vcenter dt tcenter mr20 br2">
      <div class="fs24 mt5">{{day}}</div>
      <div class="fs12">{{month}}</div>
    </div>
    <div class="nm dinline-block vcenter  lh17">
      {{item.title}}
    </div>
  </div>
</template>

<script>
export default {
  name: "notice-item",
  props: [
    'item',
  ],
  data(){
    return {
      day:'01',
      month:'12'
    }
  },
  methods:{
    goRoute(id){
      let path = `/train/notice/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      //this.$router.push({path:'/train/notice/detail',query:{id:id}})
    },
  },
  mounted() {
    var date = new Date(this.item.release_time);
    var dateTime = date.getTime() / 1000;
    this.month = this.$request.date('Y-m',dateTime);
    this.day = this.$request.date('d',dateTime);
  }
}
</script>

<style scoped>
  .bnews:hover{color: #fff;font-weight: bold;}
  .bnews:hover .dt{font-weight: normal;}
  .bnews{margin-bottom: 28px;height: 65px;}
  .bnews:last-child{margin-bottom: 0;}
  .bnews .nm{width: 310px;}
  .bnews .dt{width: 65px;height: 100%;color: #fff;}
  .bnews.blue2:hover{color: #147ad8;}
  .bnews.blue2:hover .dt{background: #147ad8;}
  .bnews.blue2 .dt{background: #bdbebe;}
</style>



// WEBPACK FOOTER //
// src/components/train/index/notice-item.vue